<script lang="ts">
import { defineComponent as __MACROS_defineComponent } from "vue";
export default /*#__PURE__*/ __MACROS_defineComponent({
  name: 'Footer'
});
</script>
<template>
  <ka-container
    code="footer"
    :data="page.$info.footer">
    <ka-page-router code="page-router" />
    <!-- Container 1 -->
    <ka-container code="container-1">
      <!-- Footer -->
      <ka-container code="container-2">
        <!-- Logo -->
        <ka-container code="logo">
          <ka-image
            code="image"
            :options="{
              animationIn: null,
              lazyOptions: {
                throttle: 200,
                once: true,
                intersection: { threshold: 0.1 }
              },
              imgFit: `cover`,
              alt: `Image`
            }"
            value="https://ucarecdn.com/e10a1429-f4f5-4570-84fa-a16fa6155d1f/" />
        </ka-container>
        <!-- CGU col -->
        <ka-container code="cgu-col">
          <ka-text code="informations-legales">
            <span v-html="t('footer.container1.container2.cguCol.informationsLegales.value', `Informations légales`)" />
          </ka-text>
          <ka-text
            code="donnees-personnelles"
            :options="{
              href: { name: `donnees-personnelles` },
              click: page.donneesPersonnellesClick
            }">
            <span v-html="t('footer.container1.container2.cguCol.donneesPersonnelles.value', `Données personnelles`)" />
          </ka-text>
          <ka-text
            code="conditions-generales"
            :options="{
              href: { name: `Cgv` },
              click: page.conditionsGeneralesClick
            }">
            <span v-html="t('footer.container1.container2.cguCol.conditionsGenerales.value', `Conditions générales`)" />
          </ka-text>
          <ka-text
            code="mentions-legales"
            :options="{
              href: { name: `mentions-legales` },
              click: page.mentionsLegalesClick
            }">
            <span v-html="t('footer.container1.container2.cguCol.mentionsLegales.value', `Mentions légales`)" />
          </ka-text>
          <ka-text code="version-du-site">
            <span v-html="t('footer.container1.container2.cguCol.versionDuSite.value', `Version du site - {0}`, [page.$data.version])" />
          </ka-text>
        </ka-container>
        <!-- Contacte col -->
        <ka-container code="contacte-col">
          <ka-text code="contactez-nous">
            <span v-html="t('footer.container1.container2.contacteCol.contactezNous.value', `Contactez-nous`)" />
          </ka-text>
          <!-- Telephone -->
          <ka-container code="telephone">
            <ka-icon
              code="icon"
              value="i-fa-solid:phone fa-rotate-90" />
            <ka-text code="k-0972264399">
              <span v-html="t('footer.container1.container2.contacteCol.telephone.k0972264399.value', `09 72 26 43 99`)" />
            </ka-text>
          </ka-container>
          <!-- mail -->
          <ka-container code="mail">
            <ka-icon
              code="icon-1"
              value="i-fa-regular:envelope" />
            <ka-text code="contact-matchers-fr">
              <span v-html="t('footer.container1.container2.contacteCol.mail.contactMatchersFr.value', `contact&#64;matchers.fr`)" />
            </ka-text>
          </ka-container>
          <!-- linkedin facebook -->
          <ka-container code="linkedin-facebook">
            <ka-icon
              code="icon-2"
              :options="{
                href: `https://www.linkedin.com/company/linkedin-com-company-matchers/`,
                ariaLabel: `icon`,
                click: page.icon2Click
              }"
              value="i-fa-brands:linkedin-in" />
            <ka-icon
              code="icon-3"
              :options="{
                href: `https://www.facebook.com/matchersfr`,
                ariaLabel: `icon`,
                click: page.icon3Click
              }"
              value="i-fa-brands:facebook-f" />
          </ka-container>
        </ka-container>
        <!-- News letter -->
        <ka-container code="news-letter">
          <!-- News letter -->
          <ka-container code="container-3">
            <ka-text code="inscrivez-vous-a-notre">
              <span v-html="t('footer.container1.container2.newsLetter.container3.inscrivezVousANotre.value', `Inscrivez-vous à notre newsletter`)" />
            </ka-text>
            <ka-text code="que-des-infos-utiles">
              <span v-html="t('footer.container1.container2.newsLetter.container3.queDesInfosUtiles.value', `Que des infos utiles et pas d’abus, c’est promis !`)" />
            </ka-text>
            <!-- Container -->
            <ka-container code="container-4">
              <ka-string-input
                v-model="page.saisieDeTexte.value"
                code="saisie-de-texte"
                :options="{ placeholder: t('footer.container1.container2.newsLetter.container3.container4.saisieDeTexte.placeholder', `Votre email`) }" />
              <ka-button
                code="soumettre"
                :options="{
                  ripple: true,
                  click: page.soumettreClick
                }">
                <span v-html="t('footer.container1.container2.newsLetter.container3.container4.soumettre.value', `Soumettre`)" />
              </ka-button>
            </ka-container>
          </ka-container>
        </ka-container>
      </ka-container>
    </ka-container>
  </ka-container>
</template>

<script setup lang="ts">
import { syncPageStore } from 'kapix-components-vue3'
import { footerLayout } from './Footer/store'
import './Footer/style.scss'
import './Footer/style.custom.scss'


provide('$scoped', '--m18')
const page = syncPageStore(footerLayout())
</script>
